import { faArrowLeft, faCode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/ui/button';

import type { InsuranceView } from './insuranceExport/constants';

export const SummaryFooter = ({
  defaultInsuranceView,
  defaultInsurancePages,
  insPage,
  numImages,
  onCloseDialog,
  onExport,
  onSetInsPage,
}: {
  defaultInsuranceView: string;
  defaultInsurancePages: string;
  insPage: string;
  numImages: number;
  onCloseDialog: () => void;
  onExport: (e: React.MouseEvent<HTMLButtonElement>, format: string) => void;
  onSetInsPage: (insPage: InsuranceView) => void;
}) => {
  const isPreviewMode =
    insPage === 'preview-single' || insPage === 'preview-pages';
  const showBackButton =
    defaultInsuranceView === 'appointment' &&
    defaultInsurancePages !== 'preview-pages';
  const isDevMode = insPage === 'narrative-dev-tool' || insPage === 'dev-tool';

  if (isDevMode) {
    return (
      <div className="vai-flex vai-gap-2 vai-justify-between vai-w-full">
        {showBackButton ? (
          <Button onClick={() => onSetInsPage('config')}>
            <FontAwesomeIcon icon={faArrowLeft} />
            Back
          </Button>
        ) : (
          <div />
        )}
        <div className="vai-flex vai-gap-2"></div>
      </div>
    );
  }

  if (isPreviewMode) {
    return (
      <div className="vai-flex vai-gap-2 vai-justify-between vai-w-full">
        {showBackButton ? (
          <Button onClick={() => onSetInsPage('config')}>
            <FontAwesomeIcon icon={faArrowLeft} />
            Back
          </Button>
        ) : (
          <div />
        )}
        <div className="vai-flex vai-gap-2">
          <Button onClick={onCloseDialog} variant="ghost">
            <Trans>Done</Trans>
          </Button>
          <Button data-testid="save-jpeg" onClick={(e) => onExport(e, 'jpeg')}>
            <Trans>Export JPEG</Trans>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="vai-flex vai-gap-2 vai-justify-between vai-w-full">
        <div className="vai-flex vai-gap-2">
          {['development', 'local', 'test'].includes(
            process.env.VITE_ENV ?? '',
          ) && (
            <Button onClick={() => onSetInsPage('dev-tool')} variant="ghost">
              <FontAwesomeIcon icon={faCode} />
              Dev Tool
            </Button>
          )}
        </div>
        <div className="vai-flex vai-gap-2">
          <Button onClick={onCloseDialog} variant="destructive">
            Close
          </Button>
          <Button
            onClick={() => onSetInsPage('preview-pages')}
            disabled={!numImages}
          >
            Paginated Summary
          </Button>
          <Button
            onClick={() => onSetInsPage('preview-single')}
            disabled={!numImages}
          >
            Single Page Summary
          </Button>
        </div>
      </div>
    </>
  );
};
